// Global management of audio context.


import {isAndroidMobile, isIos} from "../utils/browser.ts";

export let context: AudioContext | null = null;

let originalAudioContextImplementation: any | undefined;
const capturedAudioContexts: AudioContext[] = [];

/**
 * Hook into the native audio context implementation to track contexts for iOS compatibility.
 * After the first interaction, we attempt to resume each audio context to allow videos with audio to play.
 */
export function hookAudioContext()
{
    if (!isIos() && !isAndroidMobile())
        return;

    const native = window.AudioContext || (window as any).webkitAudioContext;
    if (!native) return;

    originalAudioContextImplementation = native;

    function WrappedAudioContext(this: any, ...args: any[]) {
        const ctx = new (native as any)(...args) as AudioContext;
        capturedAudioContexts.push(ctx);
        return ctx;
    }

    WrappedAudioContext.prototype = (native as any).prototype;
    (window as any).AudioContext = WrappedAudioContext as any;
    (window as any).webkitAudioContext = WrappedAudioContext as any;
}


/**
 * Create the audio context on initial first interaction.
 */
export function init()
{
    for (const ctx of capturedAudioContexts) {
        if (ctx.state === "suspended")
            void ctx.resume(); // don't await here
    }

    if (context) {
        if (context.state === "suspended")
            void context.resume();
        return;
    }

    // create the context
    context = new (originalAudioContextImplementation ?? AudioContext)();

    // iOS - allow sound with muted ringer
    try {
        // @ts-ignore
        if (navigator.audioSession && navigator.audioSession.type !== "playback") {
            // @ts-ignore
            navigator.audioSession.type = "playback";
        }
    } catch (e) {
        console.error("Error changing audio session type:", e);
    }
}

export function resume() {
    for (const ctx of capturedAudioContexts) {
        if (ctx.state === "suspended") {
            void ctx.resume(); // don't await here
            console.log("XXX Resumed another audio context:", ctx);
        }
    }

    // don't continue if there's no audio context
    if (!context)
        return;

    // resume context if we are becoming unpaused
    void context.resume();
}
